import { SelectMui } from 'src/components/SelectMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.4rem;
  max-width: 1500px;
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: start;
  margin-top: 1.2rem;
`

export const CustomSelect = styled(SelectMui)`
  width: 20rem;
`
